module.exports = __webpack_public_path__ + "img/20200801-1.cdb5135f.png";